import React, { memo, useState, useEffect, useId } from "react";
import { ResponsivePieCanvas } from "@nivo/pie";
import { useRef } from "react";
import { Loader } from "../Util/common";
import { KendoLoader } from "../Kendo/kendo_loader";

const NivoPieChart = ({
  data,
  IsGeneralReview,
  IsFormalReview,
  IsMissedCall,
  IsOutingcalls,
  IsDecor,
  IsUpselling,
  id,
  dollar,
  getRef = () => {},
  refreshId,
  isTotalZero
}) => {
  if (!data || !Array.isArray(data) || data.length === 0 || isTotalZero) {
    return <div className="Nodata">No data available</div>;
  }
  const [isLessThan700px, setIsLessThan700px] = useState(false);

  const Chartref = useRef();

  useEffect(() => {
    getRef(Chartref);
  }, [refreshId]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1251) {
        setIsLessThan700px(true);
      } else {
        setIsLessThan700px(false);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Display loading message if data is not yet available
  if (
    !data ||
    data.length == 0 ||
    (data && data.length > 0 && typeof data[0] != "object")
  ) {
    return <KendoLoader />;
  }

  const customTheme = {
    labels: {
      text: {
        fontFamily: "optimare",
        fontWeight: "bold",
        fontSize: 12,
      },
    },
    legends: {
      text: {
        fontFamily: "optimare",
        fontWeight: "bold",
        fontSize: 12,
      },
    },
  };

  return (
    <>
      <div ref={id} style={{ width: "100%", height: "100%" }}>
        <ResponsivePieCanvas
          data={data}
          theme={customTheme}
          margin={
            IsMissedCall || IsOutingcalls
              ? { top: 40, right: 80, bottom: 50, left: 60 }
              : isLessThan700px && IsDecor
              ? { top: 40, right: 80, bottom: 50, left: 100 }
              : isLessThan700px && IsUpselling
              ? { top: 40, right: 100, bottom: 50, left: 100 }
              : { top: 40, right: 20, bottom: 50, left: 40 }
          }
          innerRadius={IsOutingcalls ? 0 : 0.5}
          padAngle={0.7}
          cornerRadius={3}
          activeOuterRadiusOffset={8}
          borderWidth={1}
          borderColor={{
            from: "color",
            modifiers: [["darker", 0.2]],
          }}
          arcLinkLabelsSkipAngle={10}
          arcLinkLabelsTextColor="#333333"
          arcLinkLabelsThickness={2}
          arcLinkLabelsColor={{ from: "color" }}
          arcLabelsSkipAngle={10}
          arcLabelsTextColor={{
            from: "color",
            modifiers: [["darker", 2]],
          }}
          valueFormat={(e) => {
            if (dollar) {
              return `$${(e / 1000).toFixed(1)}K`;
            } else {
              return e;
            }
          }}
          legends={
            isLessThan700px && IsDecor
              ? [
                  {
                    anchor: IsMissedCall || IsOutingcalls ? "right" : "bottom",
                    direction: IsMissedCall || IsOutingcalls ? "column" : "row",
                    justify: false,
                    translateX: IsMissedCall || IsOutingcalls ? 33 : 0,
                    translateY: IsMissedCall || IsOutingcalls ? 0 : 50,
                    itemWidth:
                      IsMissedCall || IsOutingcalls
                        ? 0
                        : IsDecor || IsGeneralReview
                        ? 80
                        : 80,
                    itemHeight: IsMissedCall || IsOutingcalls ? 20 : 18,
                    itemTextColor: "#999",
                    itemDirection: "left-to-right",
                    itemOpacity: 1,
                    symbolSize: 10,
                    symbolShape: "circle",
                  },
                ]
              : [
                  {
                    anchor: IsMissedCall || IsOutingcalls ? "right" : "right",
                    direction: IsMissedCall || IsOutingcalls ? "column" : "column",
                    justify: false,
                    translateX: IsMissedCall || IsOutingcalls ? 33 : 33,
                    translateY: IsMissedCall || IsOutingcalls ? 0 : 0,
                    itemWidth:
                      IsMissedCall || IsOutingcalls
                        ? 0
                        : IsDecor || IsGeneralReview
                        ? 80
                        : 60,
                    itemHeight: IsMissedCall || IsOutingcalls ? 20 : 20,
                    itemTextColor: "#999",
                    itemDirection: "left-to-right",
                    itemOpacity: 1,
                    symbolSize: 10,
                    symbolShape: "circle",
                  },
                ]
          }
        />
      </div>
    </>
  );
};

export default NivoPieChart;
